var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6356 12.8H6.3812M8.79934 17.6H6.3812M16.0538 8H6.3812M20.89 7.76V20.24C20.89 22.2562 20.89 23.2643 20.4947 24.0344C20.1469 24.7118 19.592 25.2625 18.9095 25.6076C18.1336 26 17.1179 26 15.0865 26H7.34846C5.31703 26 4.30131 26 3.52541 25.6076C2.84291 25.2625 2.28802 24.7118 1.94026 24.0344C1.54492 23.2643 1.54492 22.2562 1.54492 20.24V7.76C1.54492 5.74381 1.54492 4.73572 1.94026 3.96563C2.28802 3.28825 2.84291 2.73752 3.52541 2.39238C4.30131 2 5.31703 2 7.34846 2H15.0865C17.1179 2 18.1336 2 18.9095 2.39238C19.592 2.73752 20.1469 3.28825 20.4947 3.96563C20.89 4.73572 20.89 5.74381 20.89 7.76Z",
    stroke: "#377DFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.23961a61c00a6570a9f9ff923d66b611.svg";
export { ForwardRef as ReactComponent };